window.addEventListener('load', () => {

    // function fixVerticalArrows() {
    //     const h = ($jq('.slick-active').find("img").height() / 2);
    //     $jq('.btn--prev').css('top', h + 'px');
    //     $jq('.btn--next').css('top', h + 'px');
    // }
    //
    // function fixLeftAndRightArrowsPosition() {
    //     const windowWidth = $jq(window).width()
    //     if (windowWidth < 1180 && windowWidth >= 768) {
    //         $jq('.btn--prev').css('left', '60px');
    //         $jq('.btn--next').css('right', '60px');
    //     } else if (windowWidth < 768 && windowWidth > 360) {
    //         $jq('.btn--prev').css('left', '40px');
    //         $jq('.btn--next').css('right', '40px');
    //     } else if (windowWidth <= 360) {
    //         $jq('.btn--prev').css('left', '30px');
    //         $jq('.btn--next').css('right', '30px');
    //     } else {
    //         $jq('.btn--prev').css('left', '210px');
    //         $jq('.btn--next').css('right', '210px');
    //     }
    // }

    // $jq('.slideshow').on('init', function () {
    //     fixVerticalArrows();
    //     fixLeftAndRightArrowsPosition()
    // });

    // $jq('.slideshow').on('afterChange', function () {
    //     fixVerticalArrows();
    //     fixLeftAndRightArrowsPosition()
    // });

    // $jq(window).resize(function () {
    //     fixVerticalArrows()
    //     fixLeftAndRightArrowsPosition()
    // })


    $jq('.slideshow').slick({
        speed: 500,
        centerMode: true,
        slidesToShow: 1,
        centerPadding: '170px',
        prevArrow: $jq('.btn--prev'),
        nextArrow: $jq('.btn--next'),
        variableWidth: true,
        responsive: [{

            breakpoint: 1200,
            settings: {
                centerPadding: '50px',
            }

        }, {

            breakpoint: 768,
            settings: {
                centerPadding: '35px',
            }
        }, {

            breakpoint: 360,
            settings: {
                centerPadding: '15px',
            }
        }]
    });

    const slideshowContainer = $jq('.slideshow-container')
    $jq('.article-slideshow').replaceWith(slideshowContainer)
    slideshowContainer.removeClass('d-none')
    // fixVerticalArrows()
    // fixLeftAndRightArrowsPosition()

    const config = { attributes: true, childList: true, subtree: true };
    const observer = new MutationObserver(function (_, observer) {
        // fixVerticalArrows()
        // fixLeftAndRightArrowsPosition()
        observer.disconnect()
    });
    if(!slideshowContainer[0]) return
    observer.observe(slideshowContainer[0], config);
})
